import { useCallback } from 'react';
import { useOrgId } from '@atlassian/jira-router-resources-navigation-org-id/src/index.tsx';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { TownsquareGoalAri } from '@atlassian/ari/townsquare/goal';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsStagingOrDevOrLocal } from '@atlassian/jira-tenant-context-controller/src/components/environment/index.tsx';
import { ATLASSIAN_HOME_URL, ATLASSIAN_HOME_URL_STAGING } from './constants.tsx';

type GoalUrlConstructorParam = {
	ari: string;
	key: string;
};

export const useGoalUrlConstructor = (): (({ ari, key }: GoalUrlConstructorParam) => string) => {
	const cloudId = useCloudId();
	const { data: orgId } = useOrgId();
	const isStagingOrDevOrLocal = useIsStagingOrDevOrLocal();
	const atlassianHomeUrl = isStagingOrDevOrLocal ? ATLASSIAN_HOME_URL_STAGING : ATLASSIAN_HOME_URL;

	return useCallback(
		({ ari, key }: GoalUrlConstructorParam) => {
			if (fg('jira_nin_goals_smart_link_fix')) {
				const siteId = TownsquareGoalAri.parse(ari).siteId;
				return `${atlassianHomeUrl}/o/${orgId}/s/${siteId}/goal/${key}`;
			}

			return `${atlassianHomeUrl}/o/${orgId}/s/${cloudId}/goal/${key}`;
		},
		[atlassianHomeUrl, cloudId, orgId],
	);
};

export const getGoalKeyFromUrl = (url: string): string | undefined => url.split('/').pop();
